import React from 'react';
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonIcon,
  IonButton,
  IonText
} from '@ionic/react';
import { 
  alertCircleOutline, 
  refreshOutline, 
  calendarOutline,
  peopleOutline,
  locationOutline,
  cloudOfflineOutline
} from 'ionicons/icons';
import './EmptyStateMessage.css';

interface EmptyStateMessageProps {
  type: 'schedule' | 'speakers' | 'locations' | 'error' | 'offline';
  message?: string;
  onRefresh?: () => void;
}

const EmptyStateMessage: React.FC<EmptyStateMessageProps> = ({ type, message, onRefresh }) => {
  // Configuración según el tipo
  const getConfig = () => {
    switch (type) {
      case 'schedule':
        return {
          icon: calendarOutline,
          title: 'No hay agenda disponible',
          defaultMessage: 'No se encontró información de agenda para este evento.',
          color: 'warning'
        };
      case 'speakers':
        return {
          icon: peopleOutline,
          title: 'No hay conferencistas',
          defaultMessage: 'No se encontraron conferencistas para este evento.',
          color: 'warning'
        };
      case 'locations':
        return {
          icon: locationOutline,
          title: 'No hay ubicaciones',
          defaultMessage: 'No se encontraron ubicaciones para este evento.',
          color: 'warning'
        };
      case 'offline':
        return {
          icon: cloudOfflineOutline,
          title: 'Sin conexión',
          defaultMessage: 'No hay conexión a internet. Algunas funciones pueden estar limitadas.',
          color: 'medium'
        };
      case 'error':
      default:
        return {
          icon: alertCircleOutline,
          title: 'Error al cargar datos',
          defaultMessage: 'Ocurrió un error al cargar la información. Por favor, intenta nuevamente.',
          color: 'danger'
        };
    }
  };

  const config = getConfig();

  return (
    <IonCard className="empty-state-card">
      <IonCardHeader>
        <div className="empty-state-icon-container">
          <IonIcon
            icon={config.icon}
            color={config.color}
            className="empty-state-icon"
          />
        </div>
        <IonCardTitle className="empty-state-title">{config.title}</IonCardTitle>
      </IonCardHeader>
      <IonCardContent className="empty-state-content">
        <IonText color="medium">
          <p>{message || config.defaultMessage}</p>
        </IonText>
        
        {onRefresh && (
          <IonButton 
            expand="block" 
            fill="outline" 
            onClick={onRefresh}
            className="empty-state-button"
          >
            <IonIcon slot="start" icon={refreshOutline} />
            Intentar nuevamente
          </IonButton>
        )}
      </IonCardContent>
    </IonCard>
  );
};

export default EmptyStateMessage;
